<ion-header>
  <ion-toolbar>
    <ion-title>Just Test v2</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding" style="--background: white;">
  <div style="padding: 20px; background: white; min-height: 100%; position: relative; z-index: 9999;">

    <h1 style="color: red; font-size: 24px;">BUILD v2 - NEW VERSION</h1>
    <h3>Capacitor Native Tests</h3>

    <!-- Run All Button -->
    <button (click)="runAllTests()" style="width: 100%; padding: 15px; margin: 10px 0; background: #3880ff; color: white; border: none; border-radius: 5px; font-size: 16px;">
      RUN ALL TESTS
    </button>

    <!-- Clear Button -->
    <button (click)="clearResults()" style="width: 100%; padding: 15px; margin: 10px 0; background: #666; color: white; border: none; border-radius: 5px; font-size: 16px;">
      CLEAR RESULTS
    </button>

    <hr style="margin: 20px 0;">

    <!-- Individual Tests -->
    <div style="margin: 20px 0;">
      <button (click)="testPlatformInfo()" style="width: 100%; padding: 12px; margin: 5px 0; background: #5260ff; color: white; border: none; border-radius: 5px;">
        Test Platform
      </button>
      @if (results.platform) {
        <div style="padding: 10px; background: #f4f4f4; margin: 5px 0; border-radius: 5px; white-space: pre-wrap;">
          {{ results.platform }}
        </div>
      }
    </div>

    <div style="margin: 20px 0;">
      <button (click)="testAppInfo()" style="width: 100%; padding: 12px; margin: 5px 0; background: #5260ff; color: white; border: none; border-radius: 5px;">
        Test App Info
      </button>
      @if (results.appInfo) {
        <div style="padding: 10px; background: #f4f4f4; margin: 5px 0; border-radius: 5px; white-space: pre-wrap;">
          {{ results.appInfo }}
        </div>
      }
    </div>

    <div style="margin: 20px 0;">
      <button (click)="testCamera()" style="width: 100%; padding: 12px; margin: 5px 0; background: #5260ff; color: white; border: none; border-radius: 5px;">
        Test Camera
      </button>
      @if (results.camera) {
        <div style="padding: 10px; background: #f4f4f4; margin: 5px 0; border-radius: 5px; white-space: pre-wrap;">
          {{ results.camera }}
        </div>
      }
    </div>

    <div style="margin: 20px 0;">
      <button (click)="testGallery()" style="width: 100%; padding: 12px; margin: 5px 0; background: #5260ff; color: white; border: none; border-radius: 5px;">
        Test Gallery
      </button>
      @if (results.gallery) {
        <div style="padding: 10px; background: #f4f4f4; margin: 5px 0; border-radius: 5px; white-space: pre-wrap;">
          {{ results.gallery }}
        </div>
      }
    </div>

    <div style="margin: 20px 0;">
      <button (click)="testGeolocation()" style="width: 100%; padding: 12px; margin: 5px 0; background: #5260ff; color: white; border: none; border-radius: 5px;">
        Test Geolocation
      </button>
      @if (results.geolocation) {
        <div style="padding: 10px; background: #f4f4f4; margin: 5px 0; border-radius: 5px; white-space: pre-wrap;">
          {{ results.geolocation }}
        </div>
      }
    </div>

    <div style="margin: 20px 0;">
      <button (click)="testStorage()" style="width: 100%; padding: 12px; margin: 5px 0; background: #5260ff; color: white; border: none; border-radius: 5px;">
        Test Storage
      </button>
      @if (results.storage) {
        <div style="padding: 10px; background: #f4f4f4; margin: 5px 0; border-radius: 5px; white-space: pre-wrap;">
          {{ results.storage }}
        </div>
      }
    </div>

    <div style="margin: 20px 0;">
      <button (click)="testKeyboard()" style="width: 100%; padding: 12px; margin: 5px 0; background: #5260ff; color: white; border: none; border-radius: 5px;">
        Test Keyboard
      </button>
      @if (results.keyboard) {
        <div style="padding: 10px; background: #f4f4f4; margin: 5px 0; border-radius: 5px; white-space: pre-wrap;">
          {{ results.keyboard }}
        </div>
      }
    </div>

    <div style="margin: 20px 0;">
      <button (click)="testBrowser()" style="width: 100%; padding: 12px; margin: 5px 0; background: #5260ff; color: white; border: none; border-radius: 5px;">
        Test Browser
      </button>
      @if (results.browser) {
        <div style="padding: 10px; background: #f4f4f4; margin: 5px 0; border-radius: 5px; white-space: pre-wrap;">
          {{ results.browser }}
        </div>
      }
    </div>

    <div style="margin: 20px 0;">
      <button (click)="testFilePicker()" style="width: 100%; padding: 12px; margin: 5px 0; background: #5260ff; color: white; border: none; border-radius: 5px;">
        Test File Picker
      </button>
      @if (results.filePicker) {
        <div style="padding: 10px; background: #f4f4f4; margin: 5px 0; border-radius: 5px; white-space: pre-wrap;">
          {{ results.filePicker }}
        </div>
      }
    </div>

    <div style="margin: 20px 0;">
      <button (click)="testNotifications()" style="width: 100%; padding: 12px; margin: 5px 0; background: #5260ff; color: white; border: none; border-radius: 5px;">
        Test Notifications
      </button>
      @if (results.notifications) {
        <div style="padding: 10px; background: #f4f4f4; margin: 5px 0; border-radius: 5px; white-space: pre-wrap;">
          {{ results.notifications }}
        </div>
      }
    </div>

  </div>
</ion-content>
